import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20digital%20entertainment%20abstract%20background%20with%20flowing%20gradient%20waves%20in%20warm%20orange%20and%20coral%20tones%2C%20geometric%20shapes%2C%20play%20button%20icons%2C%20dynamic%20fluid%20design%2C%20dark%20background%20with%20glowing%20elements%2C%20cinematic%20lighting%2C%20ultra%20wide%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="黄瓜视频 - 高清短视频平台"
          className="w-full h-full object-cover object-top"
          title="黄瓜视频 - 高清短视频平台官方入口"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-[fadeInUp_0.8s_ease-out]">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 text-primary-200 text-sm font-medium mb-6">
            <i className="ri-fire-line mr-1.5"></i>2026年度最受欢迎短视频平台
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-6 animate-[fadeInUp_0.8s_ease-out_0.1s]">
          海量高清视频
          <br />
          <span className="text-primary-400">随时随地 畅享精彩</span>
        </h1>

        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed animate-[fadeInUp_0.8s_ease-out_0.2s]">
          黄瓜视频汇聚多元化创作者，覆盖娱乐、生活、美食、科技等丰富类目，
          <br className="hidden md:block" />
          提供高清流畅的播放体验，支持免费在线观看与下载
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.3s]">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-download-2-line text-lg"></i>
            立即下载APP
          </a>
          <Link
            to="/category/entertainment"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-full font-medium text-base hover:bg-white/20 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            在线观看
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12 animate-[fadeInUp_0.8s_ease-out_0.4s]">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5000万+</div>
            <div className="text-xs md:text-sm text-white/50 mt-1">日活用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">100万+</div>
            <div className="text-xs md:text-sm text-white/50 mt-1">优质创作者</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">8大</div>
            <div className="text-xs md:text-sm text-white/50 mt-1">内容类目</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}